/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Injectable} from '@angular/core';

@Injectable()
export class HotKeyService {
    private hotKeyCallbacks: Map<string, () => void>;

    constructor() {
        this.hotKeyCallbacks = new Map<string, () => {}>();
    }

    public addCallback(key: string, func: () => void) {
        this.hotKeyCallbacks.set(key, func);
    }

    public removeCallback(key) {
        this.hotKeyCallbacks.delete(key);
    }

    public clear() {
        this.hotKeyCallbacks.clear();
    }

    public trigger(key) {
        const func = this.hotKeyCallbacks.get(key);
        if (func && (typeof func === 'function')) {
            func();
        }
    }
}
